import { StepIndicator } from 'components/layout/StepIndicator';
import { URLS } from 'config';

export const QUERY_STEPS: StepIndicator[] = [
  {
    name: 'Welcome',
    url: URLS.enquiryWelcome,
  },
  {
    name: 'Contact Details',
    url: URLS.enquiryContactDetails,
  },
  {
    name: 'Work Details',
    url: URLS.enquiryWorkDetails,
  },
  {
    name: 'Project Budget',
    url: URLS.enquiryProjectBudget,
  },
  {
    name: 'Finish',
    url: URLS.enquiryComplete,
  },
];

export const QUOTE_STEPS: StepIndicator[] = [
  {
    name: 'Welcome',
    url: URLS.enquiryQuoteWelcome,
  },
  {
    name: 'Contact Details',
    url: URLS.enquiryQuoteContactDetails,
  },
  {
    name: 'Upload Quote',
    url: URLS.enquiryQuoteUploadQuote,
  },
  {
    name: 'Confirm Details',
    url: URLS.enquiryQuoteConfirmDetails,
  },
  {
    name: 'Finish',
    url: URLS.enquiryQuoteComplete,
  },
];
